"use client";

import {AutoTable} from "@/features/components/AutoTable";
import React from "react";
import {DndProvider} from "react-dnd";
import {HTML5Backend} from 'react-dnd-html5-backend'

export default function NewAppPage() {
    return (
        <div className="p-4 text-center">
            <DndProvider backend={HTML5Backend}>
                <AutoTable></AutoTable>
            </DndProvider>
        </div>
    );
}